"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ChangeDetectionStrategy, Component, Input, } from '@angular/core';
var BudgetComponent = (function () {
    function BudgetComponent() {
        /** The length of the component text output. */
        this.length = 'long';
    }
    Object.defineProperty(BudgetComponent.prototype, "min", {
        /** The minimum budget. Can be optional as long as maximum budget is defined. */
        get: function () {
            return this._min;
        },
        set: function (value) {
            this._min = value ? Number(value) : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BudgetComponent.prototype, "max", {
        /** The maximum budget. Can be optional as long as minimum budget is defined. */
        get: function () {
            return this._max;
        },
        set: function (value) {
            this._max = value ? Number(value) : undefined;
        },
        enumerable: true,
        configurable: true
    });
    BudgetComponent.prototype.budgetExists = function (budget) {
        return !!budget;
    };
    BudgetComponent.prototype.ngAfterViewInit = function () {
        // Throw an error if min or max is undefined
        if (!this._min && !this._max) {
            throw new Error('Specify a min and/or a max for fl-budget.');
        }
        if (this._min !== undefined && Number.isNaN(this._min)) {
            throw new Error("The min value converts to NaN, which it shouldn't be.");
        }
        if (this._max !== undefined && Number.isNaN(this._max)) {
            throw new Error("The max value converts to NaN, which it shouldn't be.");
        }
        if (!this.currencyCode) {
            throw new Error('Missing currency code on fl-budget.');
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], BudgetComponent.prototype, "currencyCode", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], BudgetComponent.prototype, "length", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], BudgetComponent.prototype, "min", null);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], BudgetComponent.prototype, "max", null);
    BudgetComponent = __decorate([
        Component({
            selector: 'fl-budget',
            template: "\n    <ng-container *ngIf=\"budgetExists(_min) && budgetExists(_max)\">\n      {{ min | currency:currencyCode:true:'1.0-0' }} - {{ max | number:'1.0-0' }}\n    </ng-container>\n    <ng-container *ngIf=\"budgetExists(_min) && !budgetExists(_max)\">\n      < {{ min | currency:currencyCode:true:'1.0-0' }}\n    </ng-container>\n    <ng-container *ngIf=\"!budgetExists(_min) && budgetExists(_max)\">\n      > {{ max | currency:currencyCode:true:'1.0-0' }}\n    </ng-container>\n    <ng-container *ngIf=\"length === 'long'\">{{ currencyCode }}</ng-container>\n  ",
            changeDetection: ChangeDetectionStrategy.OnPush,
        })
    ], BudgetComponent);
    return BudgetComponent;
}());
export { BudgetComponent };



// WEBPACK FOOTER //
// budget.component.js